module.exports = __webpack_public_path__ + "static/media/xray-training-medial-flex4.8252dffb.png";